import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "232",
  height: "82",
  fill: "none"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("g", { "clip-path": "url(#a)" }, [
  /*#__PURE__*/_createElementVNode("path", {
    fill: "#fff",
    d: "m98.334 33.327-5.917 5.616L111.5 57.137l42.417-40.342L148 11.179l-36.5 34.646zm54.249 7.198q0 7.04-2.833 13.29T142 64.69t-11.5 7.317-14.083 2.69q-7.417 0-14.084-2.69-6.582-2.69-11.5-7.317-4.915-4.627-7.75-10.876-2.832-6.25-2.833-13.29 0-7.04 2.834-13.289Q86 20.987 90.917 16.32q4.916-4.666 11.5-7.356t14-2.69q2.75.001 5.166.356a41 41 0 0 1 4.75.99l5.584-4.035A82 82 0 0 0 124 1.568a41.3 41.3 0 0 0-8.25-.83q-8.75 0-16.5 3.163-7.666 3.165-13.458 8.662a41 41 0 0 0-9.125 12.775Q73.334 32.694 73.333 41t3.334 15.662a41 41 0 0 0 9.125 12.775q5.79 5.497 13.458 8.662 7.75 3.164 16.5 3.164t16.5-3.164q7.667-3.165 13.458-8.662a41 41 0 0 0 9.125-12.775q3.334-7.356 3.334-15.662z"
  })
], -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("defs", null, [
  /*#__PURE__*/_createElementVNode("clipPath", { id: "a" }, [
    /*#__PURE__*/_createElementVNode("path", {
      fill: "#fff",
      d: "M0 81.5h232V.5H0z"
    })
  ])
], -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }